import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../util/utility";

const initialState = {
  result: [],
  loading: false,
  error: false,
  errorCode: null,
  message: null,
  success: false,
  kits: [],
  testList: []
};

const resetAdminPortalStore = (state, action) => {
  return updateObject(state, initialState);
};

const createViomeKitStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const createViomeKit = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const createViomeKitSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: false,
    result: action.result,
    message: action.message,
    success: true
  });
};

const createViomeKitFail = (state, action) => {
  return updateObject(state, {
    error: true,
    loading: false,
    errorCode: action.error
  });
};

const removeViomeKitStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const removeViomeKit = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const removeViomeKitSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: false,
    result: action.result,
    message: action.message,
    success: true
  });
};

const removeViomeKitFail = (state, action) => {
  return updateObject(state, {
    error: true,
    loading: false,
    errorCode: action.error
  });
};

const updateViomeKitStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const updateViomeKit = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const updateViomeKitSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: false,
    result: action.result,
    message: action.message,
    success: true
  });
};

const updateViomeKitFail = (state, action) => {
  return updateObject(state, {
    error: true,
    loading: false,
    errorCode: action.error
  });
};

const loadViomeTestsStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const loadViomeTestsSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: false,
    message: action.message,
    tests: action.tests,
    testList: action.testList
  });
};

const loadViomeTestsFail = (state, action) => {
  return updateObject(state, {
    error: true,
    loading: false,
    errorCode: action.error
  });
};

const loadViomeKitsStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const loadViomeKitsSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: false,
    message: action.message,
    kits: action.kits,
    kitList: action.kitList
  });
};

const loadViomeKitsFail = (state, action) => {
  return updateObject(state, {
    error: true,
    loading: false,
    errorCode: action.error
  });
};

const updateViomeTestStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const updateViomeTest = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const updateViomeTestSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: false,
    message: action.message,
    testList: action.testList,
    success: true
  });
};

const updateViomeTestFail = (state, action) => {
  return updateObject(state, {
    error: true,
    loading: false,
    errorCode: action.error
  });
};

const createViomeTestStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const createViomeTest = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const createViomeTestSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: false,
    result: action.result,
    message: action.message,
    success: true
  });
};

const createViomeTestFail = (state, action) => {
  return updateObject(state, {
    error: true,
    loading: false,
    errorCode: action.error
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.RESET_ADMIN_PORTAL_STORE:
      return resetAdminPortalStore(state, action);

    case actionTypes.LOAD_VIOME_KITS_START:
      return loadViomeKitsStart(state, action);

    case actionTypes.LOAD_VIOME_KITS_SUCCESS:
      return loadViomeKitsSuccess(state, action);

    case actionTypes.LOAD_VIOME_KITS_FAIL:
      return loadViomeKitsFail(state, action);

    case actionTypes.CREATE_VIOME_KIT_START:
      return createViomeKitStart(state, action);

    case actionTypes.CREATE_VIOME_KIT:
      return createViomeKit(state, action);

    case actionTypes.CREATE_VIOME_KIT_SUCCESS:
      return createViomeKitSuccess(state, action);

    case actionTypes.CREATE_VIOME_KIT_FAIL:
      return createViomeKitFail(state, action);

    case actionTypes.DELETE_VIOME_KIT_START:
      return removeViomeKitStart(action, action);

    case actionTypes.DELETE_VIOME_KIT:
      return removeViomeKit(state, action);

    case actionTypes.DELETE_VIOME_KIT_SUCCESS:
      return removeViomeKitSuccess(state, action);

    case actionTypes.DELETE_VIOME_KIT_FAIL:
      return removeViomeKitFail(state, action);

    case actionTypes.UPDATE_VIOME_KIT_START:
      return updateViomeKitStart(action, action);

    case actionTypes.UPDATE_VIOME_KIT:
      return updateViomeKit(state, action);

    case actionTypes.UPDATE_VIOME_KIT_SUCCESS:
      return updateViomeKitSuccess(state, action);

    case actionTypes.UPDATE_VIOME_KIT_FAIL:
      return updateViomeKitFail(state, action);

    case actionTypes.LOAD_VIOME_TESTS_START:
      return loadViomeTestsStart(state, action);

    case actionTypes.LOAD_VIOME_TESTS_SUCCESS:
      return loadViomeTestsSuccess(state, action);

    case actionTypes.LOAD_VIOME_TESTS_FAIL:
      return loadViomeTestsFail(state, action);

    case actionTypes.CREATE_VIOME_TEST_START:
      return createViomeTestStart(action, action);

    case actionTypes.CREATE_VIOME_TEST:
      return createViomeTest(state, action);

    case actionTypes.CREATE_VIOME_TEST_SUCCESS:
      return createViomeTestSuccess(state, action);

    case actionTypes.CREATE_VIOME_TEST_FAIL:
      return createViomeTestFail(state, action);

    case actionTypes.UPDATE_VIOME_TEST_START:
      return updateViomeTestStart(action, action);

    case actionTypes.UPDATE_VIOME_TEST:
      return updateViomeTest(state, action);

    case actionTypes.UPDATE_VIOME_TEST_SUCCESS:
      return updateViomeTestSuccess(state, action);

    case actionTypes.UPDATE_VIOME_TEST_FAIL:
      return updateViomeTestFail(state, action);

    default:
      return state;
  }
};

export default reducer;
